import makeStyles from "@mui/styles/makeStyles";
import { RenderableColumnDefinition } from "components/grid/gridTypings";
import Header from "components/tableSetExplorer/Header";
import TableSetGrid from "components/tableSetExplorer/TableSetGrid";
import { IColumnProps } from "devextreme-react/data-grid";

const useStyles = makeStyles(theme => ({
  flexContainer: { display: "flex", flexDirection: "column", height: "100%" },
  tableView: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    overflow: "auto"
  }
}));

interface CalculationResultTableProps<TVariables, TTable> {
  useCaseKey: string;
  useCaseVersion: string;
  calculationId: string;
  name: string;
  columnDefs?: (
    schemaName: string
  ) => RenderableColumnDefinition<IColumnProps, {}>[];
  loadData: (variables: TVariables) => Promise<TTable | null>;
  backgroundColor: string;
}
export function CalculationResultTable<TVariables, TTable>({
  useCaseKey,
  useCaseVersion,
  calculationId,
  name,
  columnDefs,
  loadData,
  backgroundColor
}: CalculationResultTableProps<TVariables, TTable>) {
  const { flexContainer, tableView } = useStyles();

  return (
    <div className={flexContainer}>
      <div key={name} className={tableView}>
        <Header name={name} backgroundColor={backgroundColor} />
        <TableSetGrid<TVariables, TTable>
          key={name}
          columnDefs={columnDefs}
          name={name}
          useCaseKey={useCaseKey}
          loadData={loadData}
          useCaseVersion={useCaseVersion}
          calculationId={calculationId}
        />
      </div>
    </div>
  );
}

export default CalculationResultTable;
